import { brand, hexToRgb } from './brand';

// Colores del PDF (arreglos RGB para jsPDF) tomados de la marca activa.
export const pdfColors = {
  band: hexToRgb(brand.colors.band),
  primary: hexToRgb(brand.colors.primary),
  onPrimary: hexToRgb(brand.colors.onPrimary),
  text: hexToRgb(brand.colors.text),
};

// Dibuja un polígono relleno (puntos absolutos en unidades de la marca) con jsPDF.
function fillPolygon(doc, pts, ox, oy, s) {
  const [first, ...rest] = pts;
  const segs = [];
  let px = first[0];
  let py = first[1];
  rest.forEach(([x, y]) => {
    segs.push([(x - px) * s, (y - py) * s]);
    px = x;
    py = y;
  });
  doc.lines(segs, ox + first[0] * s, oy + first[1] * s, [1, 1], 'F', true);
}

// Dibuja la «M» de la marca (si existe) en blanco con el triángulo interior en el acento.
function drawMark(doc, x, y, heightMm) {
  const { mark } = brand;
  const s = heightMm / mark.height;
  // La «M» ocupa de x=18 a x=98 en su caja; se alinea su borde izquierdo con x.
  const minX = Math.min(...mark.shapes.flat().map((p) => p[0]));
  const ox = x - minX * s;
  doc.setFillColor(...hexToRgb(brand.colors.accent));
  fillPolygon(doc, mark.accent, ox, y, s);
  doc.setFillColor(255, 255, 255);
  mark.shapes.forEach((shape) => fillPolygon(doc, shape, ox, y, s));
}

// Encabezado común de los PDF: banda de marca, nombre, subtítulo y título «COTIZACIÓN».
export function buildPdfHeader(doc) {
  doc.setFillColor(...pdfColors.band);
  doc.rect(0, 0, 210, 35, 'F');

  // La M (si la marca la tiene) va a la izquierda; el texto sigue centrado respecto a la página.
  if (brand.pdf.showMark && brand.mark) drawMark(doc, 14, 5.5, 24);

  doc.setTextColor(255, 255, 255);
  doc.setFontSize(18);
  doc.setFont('helvetica', 'bold');
  doc.text(brand.pdf.title, 105, 15, { align: 'center' });
  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal');
  doc.text(brand.pdf.subtitle, 105, 22, { align: 'center' });
  doc.setTextColor(...pdfColors.text);
  doc.setFontSize(20);
  doc.setFont('helvetica', 'bold');
  doc.text('COTIZACIÓN', 105, 50, { align: 'center' });
  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal');
}
